import GeneralLayout from "./GeneralLayout";

export default GeneralLayout;
